import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";

import { createSubscriptionCheckout, createTopupCheckout } from "@/lib/payments.functions";
import { getStripe, getStripeEnvironment } from "@/lib/stripe";

export function PlanCheckout({
  priceId,
  seats,
  kind = "subscription",
  returnUrl,
}: {
  priceId?: string;
  seats?: number;
  kind?: "subscription" | "topup";
  returnUrl?: string;
}) {
  const fetchClientSecret = async (): Promise<string> => {
    const environment = getStripeEnvironment();
    const target =
      returnUrl ??
      `${window.location.origin}/account?checkout=${kind === "topup" ? "topup" : "done"}`;

    const result =
      kind === "topup"
        ? await createTopupCheckout({ data: { returnUrl: target, environment } })
        : await createSubscriptionCheckout({
            data: {
              priceId: priceId ?? "",
              ...(seats ? { seats } : {}),
              returnUrl: target,
              environment,
            },
          });

    if ("error" in result) throw new Error(result.error);
    if (!result.clientSecret) throw new Error("Checkout could not be started.");
    return result.clientSecret;
  };

  return (
    <div id="checkout" className="rounded-lg border border-border bg-card p-2">
      <EmbeddedCheckoutProvider stripe={getStripe()} options={{ fetchClientSecret }}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
